import { type Routes } from '@angular/router';
import { VigilantSessionsGuard } from './shared/guards/vigilant-sessions.guard';
import { SidenavListComponent } from './shared/components/sidenav-list/sidenav-list.component';

import { HomeComponent } from './core/components/home/home.component';
import { LoginComponent } from './core/components/login/login.component';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { ParameterComponent } from './features/admin/components/parameter/parameter.component';
import { DependencyComponent } from './features/admin/components/dependency/dependency.component';
import { ModalidadSeleccionComponent } from './features/admin/components/modalidad-seleccion/modalidad-seleccion.component';
import { ActuacionContractualComponent } from './features/admin/components/actuacion-contractual/actuacion-contractual.component';
import { TipoContratoComponent } from './features/admin/components/tipo-contrato/tipo-contrato.component';
import { PerfilComponent } from './features/admin/components/perfil/perfil.component';
import { ContratoComponent } from './features/admin/components/contrato/contrato.component';
import { RangoSalarialPerfilComponent } from './features/admin/components/rango-salarial-perfil/rango-salarial-perfil.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'wapi',
    component: SidenavListComponent,
    canActivate: [VigilantSessionsGuard],
    canActivateChild: [VigilantSessionsGuard],
    children: [
      { path: 'home', component: HomeComponent },
      {
        path: 'admin',
        children: [
          { path: 'parameters', component: ParameterComponent },
          { path: 'dependencies', component: DependencyComponent },
          { path: 'modalidades-seleccion', component: ModalidadSeleccionComponent },
          { path: 'actuaciones-contractuales', component: ActuacionContractualComponent },
          { path: 'tipos-contrato', component: TipoContratoComponent },
          { path: 'perfiles', component: PerfilComponent },
          { path: 'contratos', component: ContratoComponent },
          { path: 'rangos-salariales', component: RangoSalarialPerfilComponent }
        ]
      },
      { path: '**', component: PageNotFoundComponent }
    ]
  }
];
